//@ts-nocheck
import { memo } from "react";
import ReactInputMask from "react-input-mask";
import TextField from "../TextField";
import { MaskedInputProps } from "./props.type";
import { Box } from "@mui/material";

const MaskedInput = (props: MaskedInputProps) => {
  return (
    <Box {...props.ContainerProps}>
      <ReactInputMask
        maskChar=""
        children={() => (
          <TextField
            label={props.label}
            disabled={props.disabled}
            error={props.error}
            helperText={props.error ? props.errorText : undefined}
            InputProps={props.InputProps}
          />
        )}
        {...props}
        onChange={(e) => {
          let finalValue = e.target.value;
          props.blockChars?.forEach((char) => {
            finalValue = finalValue.trim().replace(char, "");
          });

          props.setValue?.(finalValue);
          props.onChange?.(e);
        }}
      />
    </Box>
  );
};

export default memo(MaskedInput);
